import { signalStore, withState } from '@ngrx/signals';
import { permissionCrud } from '../services/api/crud-ops/permission.crud';
import { PermissionsService } from '../services/api/generated/permissions/permissions.service';
import { Permission } from '../types/permission.interface';
import { GenericState, withCrudMethods } from './generic.store';

const initialState: GenericState<Permission> = {
  entities: [],
  selectedId: null,
  cache: {},
  lastUpdated: 0,
};

export const PermissionStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withState(initialState),
  withCrudMethods<Permission, PermissionsService>(PermissionsService, permissionCrud),
);
